export default __webpack_public_path__ + "static/moneymattersbg-40724042cb4ecd14106ee398a1fe31e4.jpg";